import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IGuest } from '@bridebook/models/source/models/Weddings/Guests.types';
import {
  GuestlistActionTypes,
  IOnFirebaseGuestlistAction,
} from '@bridebook/web/lib/guestlist/action-types';
import { updateGuestsMissingEmail } from '@bridebook/web/lib/guestlist/actions/misc';

const updateGuestsMissingEmailEpic = (action$: Observable<IOnFirebaseGuestlistAction>) =>
  action$.pipe(
    ofType(GuestlistActionTypes.ON_FIREBASE_GUESTLIST),
    map((action) => {
      const guests: IGuest[] = action.payload;
      const missingEmailCount = guests.filter(
        (guest) => !guest.contacts?.email || guest.contacts.email.trim() === '',
      ).length;

      return updateGuestsMissingEmail(missingEmailCount);
    }),
  );

export default updateGuestsMissingEmailEpic;
